import { useEffect, useState } from 'react';

import type { ContentfulNavQuickLinksFragment } from '@/graphql/contentful/api';

import * as S from './NavQuickLinksVertical.styles';

export const NavQuickLinksVertical = ({
  linksCollection,
}: ContentfulNavQuickLinksFragment) => {
  const [current, setCurrent] = useState('INTRO');
  const [stepIndex, setStepIndex] = useState(-1);

  const handleScroll = () => {
    linksCollection?.items?.forEach((step, index) => {
      const element = document.getElementById(step?.url ?? '');
      if (element) {
        const elementTop = element.getBoundingClientRect().top;
        const isActive =
          elementTop >= 0 && elementTop <= window.innerHeight * 0.4;

        if (isActive) {
          setStepIndex(index);
          setCurrent(step?.url ?? '');
        }
      }
    });
  };

  const scrollToElement = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const elementTop =
        element.getBoundingClientRect().top + window.scrollY - 240;
      window.scrollTo({ top: elementTop, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [linksCollection]);
  return (
    <S.VerticalStepper className='vertical-stepper'>
      {linksCollection?.items?.map((step, index) => (
        <S.Step
          key={step?.sys.id}
          $afterStep={stepIndex > index}
          $isActive={current === step?.url}
          onClick={() => scrollToElement(step?.url ?? '#')}
        >
          <S.StepLabel className='step-label'>{step?.urlText}</S.StepLabel>
          <S.StepContainer>
            <S.StepContent className='step-content'></S.StepContent>
            <S.StepLine className='line'></S.StepLine>
          </S.StepContainer>
        </S.Step>
      ))}
    </S.VerticalStepper>
  );
};
